export default {
    ORDER_NUMBER: 'BROJ PORUDŽBINE',
    PRODUCT: 'PROIZVOD',
    SIDE_DISH: 'PRILOG',
    QUANTITY: 'KOLIČINA',
    PRICE: 'CENA',
    TOTAL_PRICE: 'UKUPNA CENA',
    TOTAL: 'UKUPNO',
    ORDER_ID: 'ID PORUDŽBINE',
    ORDER_DATE: 'DATUM PORUDŽBINE',
    ORDER_STATUS: 'STATUS PORUDŽBINE',
    ORDER_TOTAL: 'UKUPNO',
    CUSTOMER: 'KUPAC',
    CUSTOMER_FULL_NAME: 'IME I PREZIME',
    STREET: 'ULICA',
    APARTMENT: 'STAN',
    FLOOR: 'SPRAT',
    INTERCOM: 'INTERFON',
    INFO: 'INFORMACIJE O DOSTAVI/PLAĆANJU',
    PAYMENT_METHOD: 'NAČIN PLAĆANJA',
    PAYMENT_TOTAL: 'UKUPNO PLAĆANJE',
    PAYMENT_DETAILS: 'DETALJI PLAĆANJA',
    DELIVEY_METHOD: 'NAČIN DOSTAVE',
    ORDER_INFO: 'INFORMACIJE O PORUDŽBINI',
};
